export default "__VITE_ASSET__CZMIwEKN__"